import { escape2Html } from "./util-html.js"

if (!customElements.get('product-form')) {
  /**
   * HeaderMenu
   */
  class SlideshowSwiper extends HTMLElement {
    /**
     * Section settings
     * 
     * @type {{loop: Boolean, autoplay_speed: Number, pause_on_hover: Boolean, show_navigation: Boolean, use_transparent_header: Boolean}}
     */
    sectionSettings;
    
    /**
     * Swiper entity
     * 
     * @type {Swiper}
     */
    mySwiper;

    constructor() {
      super();
      this.sectionSettings = JSON.parse(escape2Html(this.getAttribute("data-settings")));
    }

    connectedCallback() {
      this.mySwiper = new Swiper(`#${this.id} .swiper-container`, {
        loop: this.sectionSettings.loop,
        autoplay: this.sectionSettings.autoplay_speed == 0 ? false : {
          delay: this.sectionSettings.autoplay_speed * 1000,
          pauseOnMouseEnter: this.sectionSettings.pause_on_hover,
        },
        slidesPerView: 1,
        slidesPerGroup: 1,
        observer: true,
        resizeObserver: true,
        navigation: {
          nextEl: `#${this.id} .swiper-btn-next`,
          prevEl: `#${this.id} .swiper-btn-prev`,
        },
        pagination: {
          el: `#${this.id} .swiper-pagination`,
          clickable: true,
        },
      });
      if (this.sectionSettings.pause_on_hover && this.sectionSettings.autoplay_speed > 0) {
        this.mySwiper.el.onmouseenter = () => {
          this.mySwiper.autoplay.stop();
        };
        this.mySwiper.el.onmouseleave = () => {
          this.mySwiper.autoplay.start();
        };
      }

      const useTransparentHeader = this.sectionSettings.use_transparent_header;
      if (useTransparentHeader) {
        const announcementBarHeight = $(".utility-bar").height();
        const headerHeight = $("sticky-header").height();
        $(`#${this.id}`).css("margin-top", 0 - announcementBarHeight - headerHeight);
      }
    }
    
  }

  customElements.define('slideshow-swiper', SlideshowSwiper);
}